'use client'

import { useEffect } from 'react'
import { bindScrollMenuTouchFix } from '@/utils/scrollMenuTouch'

export default function ScrollMenuTouchFix() {
  useEffect(() => bindScrollMenuTouchFix(), [])
  return null
}
